import React from 'react'
import agent from '../agent'
import UserTaskList from './widgets/UserTaskList'
import { connect } from 'react-redux'
import moment from 'moment';
import { Link } from 'react-router-dom'
import Loading from './widgets/Loading'
import {
    USER_TASK_LIST_LOADED,
    USER_TASK_LIST_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.task,
    appName: state.common.appName,
    token: state.common.token,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: USER_TASK_LIST_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: USER_TASK_LIST_UNLOADED })
})

class UserTasks extends React.Component {

    componentWillMount() {
        const payload = agent.Tasks.getUserTasks(this.props.match.params.key)
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        if (!this.props.user) {
            return (
                <Loading />
            )
        }
        return (
            <div className='pane'>
                <Link className="crumb" to={`/users/${this.props.user.key}`}>&laquo; back to user detail</Link>
                <h1><Link to={`/users/${this.props.user.key}`}>{this.props.user.firstname + ' ' + this.props.user.lastname + '\'s '}</Link> Task list</h1>
                <UserTaskList tasks={this.props.user_tasks} loading={this.props.loading} />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserTasks);



// WEBPACK FOOTER //
// ./src/components/UserTasks.js